import { API, Auth } from 'aws-amplify';
import React, { FC, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { RootState, useDispatch, useSelector } from 'src/store';

import {
  editTextReset,
  //
  editColor,
  editContents,
  editFontFamily,
  editFontSize,
  editFontWeight,
  editPreFontSize,
  editSubTitle,
  editText,
  editTextAlign,
  editTitle
} from 'src/store/modules/editText';
import {
  buttonsReset,
  editBtnBgColor,
  editBtnColor,
  editBtnFontFamily,
  editBtnFontSize,
  editBtnFontWeight,
  editBtnPreFontSize,
  editBtnRadius,
  editBtnText,
  editBtnTextAlign
} from 'src/store/modules/buttons';
import {
  imageReset,
  //
  editBg,
  editBgColor,
  editBgImage,
  editBgImageBlur,
  editRadius,
  editCurrentIndex,
  editDeeplink
} from 'src/store/modules/imageUpload';

import setInitValue from 'src/utils/setInitValue';
import { changeText } from 'src/utils/changeText';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/FullDualImageTracking';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const initViewValues = {
  currentIndex: 0,
  bg: 'color',
  bgImage: {
    multi_image: [
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp',
      'https://image.inappmessage.com/sample/defaultGRAYIMAGE.webp'
    ]
  },
  bgColor: {
    background: '#ffffff'
  },
  radius: { multi_image: 0, button: 0, multi_button: 0 },
  deeplink: {
    multi_image: [
      'https://www.inappmessage.com/',
      'https://www.inappmessage.com/'
    ]
  },

  text: {
    title: 'SPECIAL PRICE Only for you',
    sub_title:
      'Tap the more exciting content for you! Tap the more exciting content for you!',
    multi_title: ['SEASONAL SALE UP TO 70%', '2021 F/W ACCESSORIES'],
    multi_sub_title: ['11.13 ~ 12.31', '11.13 ~ 12.31']
  },
  fontSize: {
    title: 1.5,
    sub_title: 0.75,
    multi_title: 1,
    multi_sub_title: 1
  },
  fontWeight: {
    title: 700,
    sub_title: 400,
    multi_title: 500,
    multi_sub_title: 400
  },
  color: {
    title: '#000000',
    sub_title: '#000000',
    multi_title: '#000000',
    multi_sub_title: '#000000'
  },
  fontFamily: {
    title: 'Montserrat',
    sub_title: 'Montserrat',
    multi_title: 'Montserrat',
    multi_sub_title: 'Montserrat'
  },
  textAlign: {
    title: 'left',
    sub_title: 'left',
    multi_title: 'left',
    multi_sub_title: 'left'
  },

  btnText: { button: 'Dismiss', multi_button: ['Show now 1', 'Show now 2'] },
  btnFontSize: { button: 1, multi_button: 0.75 },
  btnFontWeight: { button: 500, multi_button: 400 },
  btnColor: { button: '#000000', multi_button: '#ffffff' },
  btnBgColorR: { button: 240, multi_button: 0 },
  btnBgColorG: { button: 240, multi_button: 0 },
  btnBgColorB: { button: 240, multi_button: 0 },
  btnBgColorA: { button: 1, multi_button: 1 },
  btnFontFamily: {
    button: 'Montserrat',
    multi_button: 'Montserrat'
  }
};

const FullDualImage: FC = () => {
  const dispatch = useDispatch();

  let clientName = useSelector((state: RootState) => state.client.userCompany);
  let templateWidth = useSelector(
    (state: RootState) => state.template.templateWidth
  );
  let templateHeight = useSelector(
    (state: RootState) => state.template.templateHeight
  );
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bg = useSelector((state: RootState) => state.imageUpload.bg);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const [currentUser, setCurrentUser] = useState('');
  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        setCurrentUser(current.attributes['custom:Company']);
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const titleFontURL = getFontURL(fontFamily?.title);
  const subTitleFontURL = getFontURL(fontFamily?.sub_title);
  const multiTitleURL = getFontURL(fontFamily.multi_title);
  const multiSubTitleURL = getFontURL(fontFamily.multi_sub_title);
  const btnURL = getFontURL(btnFontFamily?.button);
  const multiBtnURL = getFontURL(btnFontFamily?.multi_button);
  // const titleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.title}`;
  // const subTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.sub_title}`;
  // const multiTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_title}`;
  // const multiSubTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_sub_title}`;
  // const btnURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.button}`;
  // const multiBtnURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_button}`;

  const style = `
  @font-face {
    font-family: 'title';
    src: url(${titleFontURL});
  }
  @font-face {
    font-family: 'subTitle';
    src: url(${subTitleFontURL});
  }
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleURL});
  }
  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleURL});
  }
  @font-face {
    font-family: 'btn';
    src: url(${btnURL});
  }
  @font-face {
    font-family: 'multiBtn';
    src: url(${multiBtnURL});
  }

    a {
      color: #000000;
      text-decoration: none;
      cursor: pointer;
    }

    .root_view {
      width: 100%;
      height: 100%;
      padding: 0 10%;

      overflow: hidden;
      position: relative;

      ${
        bg === 'image'
          ? `background-image: url(${bgImage?.background});`
          : `background: ${bgColor?.background};`
      };

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      position: relative;

      .center_wrapper {
        width: 100%;
        padding: 0 10%;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .contents_wrapper {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
      }
      .center_wrapper .title {
        height: 3.5rem;
        display: flex;
        align-items: center;
        text-align: ${textAlign?.title};
        justify-content: ${TEXT_2_JUSTIFY[textAlign?.title]};
      }
      .title_inner {
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        color: ${color?.title};
        font-size: ${fontSize?.title}rem;
        font-weight: ${fontWeight?.title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            fontFamily?.title
          )
            ? fontFamily.title
            : 'title'
        };
      }
      .center_wrapper .sub_title {
        width: 100%;
        height: 2.5rem;

        display: flex;
        align-items: center;
      }
      .center_wrapper .sub_title_inner {
        width: 100%;

        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        text-align: ${textAlign?.sub_title};
        color: ${color?.sub_title};
        font-size: ${fontSize?.sub_title}rem;
        font-weight: ${fontWeight?.sub_title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            fontFamily?.sub_title
          )
            ? fontFamily.sub_title
            : 'subTitle'
        };
        overflow: hidden;
      }

      .contents_wrapper .image_box {
        width: 100%;
        position: relative;
      }
      .contents_wrapper .image {
        width: 100%;
        aspect-ratio: 9/5;
        border-radius: ${radius?.multi_image}px;
        object-fit: cover;
      }
      .contents_wrapper .multi_title {
        width: 100%;
        height: 2rem;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        display: flex;
        align-items: center;
        justify-content: ${TEXT_2_JUSTIFY[textAlign?.multi_title]};

        color: ${color?.multi_title};
        font-size: ${fontSize?.multi_title}rem;
        font-weight: ${fontWeight?.multi_title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            fontFamily?.multi_title
          )
            ? fontFamily?.multi_title
            : 'multiTitle'
        };
      }
      .contents_wrapper .multi_sub_title {
        height: 1.5rem;

        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        display: flex;
        align-items: center;
        justify-content: ${TEXT_2_JUSTIFY[textAlign?.multi_sub_title]};

        color: ${color?.multi_sub_title};
        font-size: ${fontSize?.multi_sub_title}rem;
        font-weight: ${fontWeight?.multi_sub_title};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            fontFamily?.multi_sub_title
          )
            ? fontFamily?.multi_sub_title
            : 'multiSubTitle'
        };
      }

      .contents_wrapper .multi_button {
        position: absolute;
        right: 1rem;
        bottom: 1rem;
      }
      .contents_wrapper button {
        padding: 0.25rem 0.75rem;
        border: 0;

        color: ${btnColor?.multi_button};
        font-size: ${btnFontSize?.multi_button}rem;
        font-weight: ${btnFontWeight?.multi_button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.multi_button
          )
            ? btnFontFamily?.multi_button
            : 'multiBtn'
        };

        border-radius: ${radius?.multi_button}px;
        background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
      }

      .bottom_wrapper {
        width: 100%;
        margin-top: 2rem;
      }
      .bottom_wrapper button {
        width: 100%;
        height: 3rem;
        
        cursor: pointer;
        outline: 0;
        border: 0;

        color: ${btnColor?.button};
        font-size: ${btnFontSize?.button}rem;
        font-weight: ${btnFontWeight?.button};
        font-family: ${
          ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
            btnFontFamily?.button
          )
            ? btnFontFamily?.button
            : 'btn'
        };
        border-radius: ${radius?.button}px;
        background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
      }

      ${
        templateHeight < 667
          ? `
          .center_wrapper {
            gap: 0rem;
          }
          .center_wrapper .title {
            height: 2.5rem;
          }
          .title_inner {
            font-size: ${fontSize?.title - 0.375}rem;
          }

          .center_wrapper .sub_title {
            height: 2rem;
            margin-bottom: 0.5rem;
          }

          .contents_wrapper .multi_title {
            height: 1.5rem;
          }
          .contents_wrapper .multi_sub_title {
            height: 1rem;
            margin-bottom: 0.5rem;
          }

          .bottom_wrapper {
            margin-top: 0rem;
          }
          `
          : ``
      }

      ${
        templateWidth > 767
          ? `
          .root_view {
            padding: 0 25%;
          }
          .close_btn {
            right: 25%;
            top: 4rem;
          }

          .center_wrapper {
            padding: 0 25%;
          }
          .center_wrapper .title {
            height: 4rem;
            font-size: ${fontSize?.title + 0.25}rem;
          }
          .center_wrapper .sub_title {
            height: 3.5rem;
            font-size: ${fontSize?.sub_title + 0.25}rem;
          }
          .center_wrapper .sub_title_inner {
            height: 2.6rem;
          }
          .contents_wrapper .image_box,
          .contents_wrapper .image {
            height: 14rem;
          }
          .contents_wrapper .multi_title {
            height: 3rem;
            font-size: ${fontSize?.multi_title + 0.5}rem;
          }

          .bottom_wrapper button {
            width: 100%;
            height: 4rem;
          }
          `
          : ``
      }
    }
  `;

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          if (
            customValues?.bgImage &&
            customValues?.text &&
            customValues?.btnText
          ) {
            setInitValue(dispatch, customValues);
          } else {
            setValue(
              dispatch,
              customValues,
              { ...initViewValues, ...initTrackingValues },
              clientName
            );
          }
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(trackingReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="center_wrapper">
          <div className="title">
            <div className="title_inner">{changeEnter(text?.title)}</div>
          </div>
          <div className="sub_title">
            <div className="sub_title_inner">
              {changeEnter(text?.sub_title)}
            </div>
          </div>
          {text?.multi_title?.map((data: any, idx: number) => {
            return (
              <div key={idx} className="contents_wrapper">
                <div className="image_box">
                  <img className="image" src={bgImage?.multi_image?.[idx]} />
                  <button className="multi_button">
                    {btnText?.multi_button?.[idx]}
                  </button>
                </div>
                <div>
                  <div className="multi_title">
                    {changeEnter(text?.multi_title?.[idx])}
                  </div>
                  <div className="multi_sub_title">
                    {changeEnter(text?.multi_sub_title?.[idx])}
                  </div>
                </div>
              </div>
            );
          })}
          <div className="bottom_wrapper">
            <button>{btnText?.button}</button>
          </div>
        </div>
      </div>
    </>
  );
};

const setValue = (
  dispatch: any,
  values: any,
  initViewValuess: any,
  clientName: any
) => {
  // console.log(values);
  // console.log('test');
  // if (values?.bgColor) dispatch(editBgColor(values?.bgColor));
  const MultiBackground = values?.imageName?.map((data: any) => {
    return `https://image.inappmessage.com/${clientName}/${data}`;
  });
  dispatch(
    editBgImage({
      multi_image: MultiBackground
    })
  );

  // if (values?.bgImageBlur) dispatch(editBgImageBlur(values?.bgImageBlur));
  dispatch(
    editDeeplink({
      multi_image: [values?.newBtn1DeepLink, values?.newBtn2DeepLink]
    })
  );
  dispatch(
    editRadius({
      ...initViewValuess?.radius,
      ...{
        multi_image: values?.newImgRadius,
        button: values?.newBtnRadius
      }
    })
  );

  dispatch(
    editText({
      title: changeText(values?.newText),
      sub_title: changeText(values?.newSubText),
      multi_title: [
        changeText(values?.newContent1),
        changeText(values?.newContent2)
      ],
      multi_sub_title: [
        changeText(values?.newSubContent1),
        changeText(values?.newSubContent2)
      ]
    })
  );
  dispatch(
    editPreFontSize({
      title: values?.newFontSize / 16,
      sub_title: values?.newSubFontSize / 16,
      multi_title: values?.newContent1FontSize / 16,
      multi_sub_title: values?.newContent2FontSize / 16
    })
  );
  dispatch(
    editFontSize({
      title: values?.newFontSize / 16,
      sub_title: values?.newSubFontSize / 16,
      multi_title: values?.newContent1FontSize / 16,
      multi_sub_title: values?.newContent2FontSize / 16
    })
  );
  dispatch(
    editFontWeight({
      title: values?.newFontWeight,
      sub_title: values?.newSubFontWeight,
      multi_title: values?.newContent1FontWeight,
      multi_sub_title: values?.newContent2FontWeight
    })
  );
  dispatch(
    editColor({
      title: values?.newTextColor,
      sub_title: values?.newSubTextColor,
      multi_title: values?.newContent1Color,
      multi_sub_title: values?.newContent2Color
    })
  );
  // dispatch(editFontFamily(values?.fontFamily));
  // dispatch(editTextAlign(values?.textAlign));

  dispatch(
    editBtnText({
      button: changeText(values?.newCloseText),
      multi_button: [
        changeText(values?.newBtnText2),
        changeText(values?.newBtnText2)
      ]
    })
  );
  dispatch(
    editBtnPreFontSize({
      button: values?.newBtn1FontSize / 16,
      multi_button: values?.newBtn2FontSize / 16
    })
  );
  dispatch(
    editBtnFontSize({
      button: values?.newBtn1FontSize / 16,
      multi_button: values?.newBtn2FontSize / 16
    })
  );
  dispatch(
    editBtnFontWeight({
      button: values?.newBtn1FontWeight,
      multi_button: values?.newBtn2FontWeight
    })
  );
  dispatch(
    editBtnColor({
      button: values?.newBtn1FontColor,
      multi_button: values?.newBtn2FontColor
    })
  );
  dispatch(
    editBtnBgColor(
      {
        button: values?.newBtn1BgColorR,
        multi_button: values?.newBtn2BgColorR
      },
      {
        button: values?.newBtn1BgColorG,
        multi_button: values?.newBtn2BgColorG
      },
      {
        button: values?.newBtn1BgColorB,
        multi_button: values?.newBtn2BgColorB
      },
      { button: values?.newBtn1BgColorA, multi_button: values?.newBtn2BgColorA }
    )
  );
  // if (values?.btnFontFamily)
  //   dispatch(editBtnFontFamily(values?.btnFontFamily));
  // if (values?.btnTextAlign)
  //   dispatch(editBtnTextAlign(values?.btnTextAlign));
};

export default FullDualImage;
